// revert-on-update: AUDIT-FIXES-1028: guard optional tickers and clean up announcement event handlers.
(function () {
  'use strict';
  const selectors = {
    marquee: '.announcement__bar-holder--marquee',
    slide: '[data-slide]',
    slider: '[data-slider]',
    ticker: 'ticker-bar',
    tickerSlide: '.announcement__slide',
  };
  if (customElements.get('announcement-bar')) return;
  customElements.define('announcement-bar', class extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector(selectors.slider);
      this.resizeEvent = () => this.resize();
      this.sliderLoadedEvent = () => this.refreshTickers();
      this.countdownHideEvent = (event) => {
        if (window.Shopify?.designMode) return;
        const ticker = this.querySelector(selectors.ticker);
        if (ticker && this.querySelectorAll(selectors.tickerSlide).length < 2) ticker.style.display = 'none';
        if (event.target.closest(selectors.marquee)) {
          this.removeTickerText(event.target.closest(selectors.tickerSlide));
        } else {
          this.removeSlide(event.target.closest(selectors.slide));
        }
      };
      this.countdownExpireEvent = () => {
        this.refreshTickers();
        this.removeEventListener('theme:countdown:expire', this.countdownExpireEvent);
      };
    }

    connectedCallback() {
      this.addEventListener('theme:slider:loaded', this.sliderLoadedEvent);
      this.addEventListener('theme:countdown:hide', this.countdownHideEvent);
      this.addEventListener('theme:countdown:expire', this.countdownExpireEvent);
      document.addEventListener('theme:resize:width', this.resizeEvent);
      document.dispatchEvent(new CustomEvent('theme:announcement:init', { bubbles: true }));
    }

    refreshTickers() {
      this.querySelectorAll(selectors.ticker).forEach((ticker) => {
        ticker.dispatchEvent(new CustomEvent('theme:ticker:refresh'));
      });
    }

    resize() {
      this.slider?.dispatchEvent(new CustomEvent('theme:slider:init', { bubbles: false }));
      this.slider?.dispatchEvent(new CustomEvent('theme:slider:reposition', { bubbles: false }));
    }

    removeSlide(slide) {
      if (!slide) return;
      this.slider?.dispatchEvent(new CustomEvent('theme:slider:remove-slide', { bubbles: false, detail: { slide } }));
    }

    removeTickerText(slide) {
      if (!slide) return;
      const ticker = slide.closest(selectors.ticker);
      if (!ticker) return;
      slide.remove();
      ticker.dispatchEvent(new CustomEvent('theme:ticker:refresh'));
    }

    disconnectedCallback() {
      this.removeEventListener('theme:slider:loaded', this.sliderLoadedEvent);
      this.removeEventListener('theme:countdown:hide', this.countdownHideEvent);
      this.removeEventListener('theme:countdown:expire', this.countdownExpireEvent);
      document.removeEventListener('theme:resize:width', this.resizeEvent);
    }
  });
})();
